import * as React from 'react'

function SvgLowFee(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 52 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle opacity={0.2} cx={26} cy={17.869} r={17} fill="#00D37E" />
      <circle opacity={0.5} cx={31.5} cy={7.369} r={1.5} fill="#00D37E" />
      <circle opacity={0.5} cx={21} cy={28.523} r={2} fill="#00D37E" />
      <path
        opacity={0.2}
        d="M33.5 17.87c0 4.637-.886 8.811-2.296 11.807-1.428 3.035-3.302 4.692-5.204 4.692-1.902 0-3.776-1.657-5.204-4.692-1.41-2.996-2.296-7.17-2.296-11.808 0-4.637.886-8.812 2.296-11.808C22.224 3.026 24.098 1.37 26 1.37c1.902 0 3.776 1.657 5.204 4.692 1.41 2.996 2.296 7.17 2.296 11.808z"
        stroke="#00D37E"
      />
      <path
        opacity={0.2}
        d="M38.5 17.87c0 4.593-1.425 8.735-3.705 11.716-2.28 2.982-5.394 4.783-8.795 4.783s-6.515-1.801-8.795-4.783c-2.28-2.981-3.705-7.122-3.705-11.717 0-4.594 1.425-8.735 3.705-11.717 2.28-2.981 5.394-4.783 8.795-4.783s6.515 1.802 8.795 4.783c2.28 2.982 3.705 7.123 3.705 11.717z"
        stroke="#00D37E"
      />
      <g filter="url(#low-fee_svg__filter0_d_1020:39298)">
        <rect x={8} y={11.869} width={36} height={13} rx={6.5} fill="#fff" />
      </g>
      <path
        d="M14.203 20.87h-2.74v-4.584h1.047v3.665h1.693v.918zm4.87-2.306c0 .703-.203 1.271-.611 1.707-.404.43-.943.646-1.619.646-.68 0-1.221-.216-1.625-.646-.403-.43-.605-1-.605-1.707 0-.703.202-1.27.605-1.7.408-.435.95-.653 1.625-.653.68 0 1.222.216 1.626.646.403.43.605 1 .605 1.707zm-3.039-1.02c-.2.25-.299.59-.299 1.02 0 .43.1.773.3 1.027.199.25.468.374.808.374s.61-.125.81-.374c.2-.254.299-.596.299-1.027 0-.43-.1-.77-.3-1.02a.975.975 0 00-.809-.38c-.34 0-.61.126-.809.38zm5.844 3.325h-1.17l-1.23-4.583h1.1L21 17.972c.091.363.166.692.225.986.059.29.095.492.109.606l.027.163c.077-.354.231-.939.462-1.755l.456-1.618h.775l.449 1.618c.095.34.179.658.251.952.077.29.13.497.157.62l.04.183c.06-.404.186-.99.381-1.762l.422-1.68h1.068l-1.224 4.584h-1.17l-.401-1.448c-.095-.35-.175-.644-.238-.884-.06-.24-.095-.395-.109-.463l-.014-.102c-.013.186-.136.669-.367 1.449l-.421 1.448zm8.783-1.727h-1.516v1.727H28.09v-4.583h2.795v.836h-1.741v1.183h1.516v.837zm3.719 1.727h-2.85v-4.583h2.823v.836h-1.768v1.04h1.577v.83h-1.577v1.04h1.795v.837zm3.699 0h-2.85v-4.583h2.822v.836h-1.768v1.04h1.578v.83h-1.578v1.04h1.796v.837zm3.699-1.333c0 .413-.152.748-.456 1.007-.304.254-.707.38-1.21.38-.54 0-.98-.095-1.32-.285v-1.054c.413.3.853.449 1.32.449a.62.62 0 00.394-.123.412.412 0 00.156-.333.406.406 0 00-.02-.13.297.297 0 00-.075-.115.622.622 0 00-.109-.088.682.682 0 00-.15-.088 3.455 3.455 0 00-.367-.184 5.1 5.1 0 00-.21-.095 2.189 2.189 0 01-.714-.503c-.177-.2-.266-.465-.266-.796 0-.395.146-.712.436-.952.29-.245.691-.367 1.203-.367.458 0 .853.077 1.184.23v.98a2.247 2.247 0 00-1.143-.32c-.177 0-.313.037-.408.11a.342.342 0 00-.136.278c0 .114.057.216.17.306.113.086.283.18.51.279.14.063.256.12.347.17.095.045.202.111.32.197a1.2 1.2 0 01.47.605c.049.136.074.284.074.442z"
        fill="#00D37E"
      />
      <defs>
        <filter
          id="low-fee_svg__filter0_d_1020:39298"
          x={0}
          y={5.869}
          width={52}
          height={29}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={4} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.662745 0 0 0 0 0.396078 0 0 0 0.2 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1020:39298"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1020:39298"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default SvgLowFee
